"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_link_style_1 = __importDefault(require("./uicon.link.style"));
class UiconLink extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { d: "M26.606 6.796l-1.402-1.402-2.469 2.469a6.415 6.415 0 00-3.718-1.22 6.309 6.309 0 00-4.48 1.86l-6.095 6.095a6.324 6.324 0 00-.64 8.198l-2.408 2.408 1.402 1.402 2.469-2.469a6.415 6.415 0 003.718 1.22 6.309 6.309 0 004.48-1.86l6.095-6.095a6.323 6.323 0 00.64-8.198l2.408-2.408zm-3.23 6.187a4.31 4.31 0 01-1.28 3.047L16 22.127a4.312 4.312 0 01-3.048 1.28 4.358 4.358 0 01-2.285-.701l2.346-2.332-1.402-1.402-2.316 2.362a4.358 4.358 0 01-.67-2.3 4.312 4.312 0 011.28-3.048L16 9.89a4.311 4.311 0 013.048-1.28 4.266 4.266 0 012.285.685l-2.362 2.332 1.402 1.402 2.332-2.362c.441.691.674 1.495.67 2.316z", className: classes.fill }, void 0) }), void 0));
        };
    }
}
UiconLink.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconLink.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_link_style_1.default)(UiconLink);
//# sourceMappingURL=uicon.link.js.map